import httpService from "./http.service";

class SpecialFeatureService {
    getSpecialFeaturesUrl = "/special-features";

    getSpecialFeatures = () => {
        return httpService.get(this.getSpecialFeaturesUrl);
    };
    createSpecialFeature = (model) => {
        return httpService.post(this.getSpecialFeaturesUrl, model, "createSpecialFeature");
    };
    editSpecialFeature = (id, model) => {
        return httpService.patch(this.getSpecialFeaturesUrl + "/" + id, model, "editSpecialFeature", {}, "patch");
    };
    deleteSpecialFeature = (id) => {
        return httpService.delete(this.getSpecialFeaturesUrl + "/" + id);
    };
}

const specialFeatureService = new SpecialFeatureService();
export default specialFeatureService;